import { VOICEOVER_QUIZ_SET_DATA } from './content/quizSet/quizSetData';
import { ADOLESCENT_QUIZ_SET_DATA } from './content/quizSet/quizSetDataAdolescent';
import { ADULT_QUIZ_SET_DATA } from './content/quizSet/quizSetDataAdult';
import { STATIC_QUIZ_SET_DATA as STATIC_QUIZ_SET_DATA_OTX202 } from './content/quizSet/quizSetDataStatic';
import { STATIC_QUIZ_SET_DATA as STATIC_QUIZ_SET_DATA_OTX207 } from './content/quizSet/quizSetDataStaticOTX207';
import { ProductVariant } from './types/graphql.generated';
export function getQuizSets(param) {
    var slug = param.slug, productSlug = param.productSlug;
    var shamQuizSetData = productSlug === ProductVariant.AVIVA_ADOLESCENT ? STATIC_QUIZ_SET_DATA_OTX207 : STATIC_QUIZ_SET_DATA_OTX202;
    var _VOICEOVER_QUIZ_SET_DATA_slug, _ref;
    var sets = (_ref = (_VOICEOVER_QUIZ_SET_DATA_slug = VOICEOVER_QUIZ_SET_DATA[slug]) !== null && _VOICEOVER_QUIZ_SET_DATA_slug !== void 0 ? _VOICEOVER_QUIZ_SET_DATA_slug : shamQuizSetData[slug]) !== null && _ref !== void 0 ? _ref : productSlug === ProductVariant.AVIVA_ADULT ? ADULT_QUIZ_SET_DATA[slug] : ADOLESCENT_QUIZ_SET_DATA[slug];
    if (!sets) {
        throw new Error("Invalid slug for getQuizSets: ".concat(slug, " (productSlug: ").concat(productSlug, ")"));
    }
    return sets;
}
